// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IBalanceDetailsResponse } from '../Billing/BalanceDetailsResponse';
import type { IRequestedHoldPayment } from '../Billing/RequestedHoldPayment';

export interface IAddServicePackageV2Response {
  balanceDetails?: IBalanceDetailsResponse;
  heldPayment?: IRequestedHoldPayment;
  /** Состояние оплаты пакета () **/
  isPaid: boolean;
  /** Номер активированного пакета **/
  servicePackageId?: number;
  /** Сообщение в случаи ошибки **/
  message?: string;
  /** Код ответа **/
  code: ECode;
}
export enum ECode {
  /** Пакет добавлен и куплен **/
  'Ok' = 'Ok',
  /** Недостаточно денег для покупки пакета **/
  'NotEnoughMoney' = 'NotEnoughMoney',
  /** Пользователь не авторизован **/
  'NotAuthorised' = 'NotAuthorised',
  /** Услуга не доступна **/
  'TariffNotAvailable' = 'TariffNotAvailable',
  /** Не выбраны услуги в пакете **/
  'ServicesNotSelected' = 'ServicesNotSelected',
  /** Общая ошибка **/
  'Error' = 'Error',
}
